var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-menu",
    {
      attrs: { "offset-y": "", left: "", "close-on-content-click": false },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function(ref) {
            var on = ref.on
            return [
              _c(
                "div",
                _vm._g({}, on),
                [
                  _c(
                    "v-tooltip",
                    {
                      attrs: { top: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function(ref) {
                              var on = ref.on
                              return [
                                _c(
                                  "v-btn",
                                  _vm._g(
                                    {
                                      staticClass: "k-header-btn",
                                      attrs: {
                                        small: "",
                                        flat: "",
                                        disabled: _vm.disabled
                                      }
                                    },
                                    !_vm.disabled
                                      ? on
                                      : (_vm.showDropdown = false)
                                  ),
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        staticClass: "material-icons-outlined"
                                      },
                                      [_vm._v("view_column")]
                                    )
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    },
                    [_vm._v(" "), _c("span", [_vm._v("Hide or show columns")])]
                  )
                ],
                1
              )
            ]
          }
        }
      ]),
      model: {
        value: _vm.showDropdown,
        callback: function($$v) {
          _vm.showDropdown = $$v
        },
        expression: "showDropdown"
      }
    },
    [
      _vm._v(" "),
      _c(
        "v-list",
        { staticClass: "k-sort-filter-menu", attrs: { subheader: "" } },
        [
          _c("v-subheader", [_vm._v("Columns:")]),
          _vm._v(" "),
          _c("v-divider"),
          _vm._v(" "),
          _c(
            "v-list-tile",
            { staticClass: "k-column-properties" },
            [
              _vm.columnList
                ? _c(
                    "draggable",
                    {
                      class: { "not-draggable": _vm.hideReorderAndLock },
                      attrs: {
                        handle: ".k-drag-active",
                        disabled: _vm.hideReorderAndLock
                      },
                      on: { end: _vm.onMoveCallback },
                      model: {
                        value: _vm.columnList,
                        callback: function($$v) {
                          _vm.columnList = $$v
                        },
                        expression: "columnList"
                      }
                    },
                    _vm._l(_vm.columnList, function(column, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          class: [
                            "k-column-draggable-item",
                            column.reorderable === false
                              ? "k-drag-disabled"
                              : "k-drag-active"
                          ]
                        },
                        [
                          _c(
                            "v-tooltip",
                            {
                              attrs: {
                                top: "",
                                attach: ".k-column-properties",
                                "nudge-top": "-40"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var tooltip = ref.on
                                      return [
                                        _c(
                                          "div",
                                          _vm._g(
                                            { staticClass: "mr-auto" },
                                            (_vm.filters &&
                                              _vm.filters.filters.some(function(
                                                c
                                              ) {
                                                return c.field === column.field
                                              })) ||
                                              (_vm.group &&
                                                _vm.group.some(function(g) {
                                                  return g.field == column.field
                                                }))
                                              ? tooltip
                                              : ""
                                          ),
                                          [
                                            _c("v-checkbox", {
                                              attrs: {
                                                label: column.title,
                                                "hide-details": "",
                                                color: "link",
                                                disabled:
                                                  _vm.isColumnFiltered(
                                                    _vm.filters,
                                                    column.field
                                                  ) ||
                                                  (_vm.group &&
                                                    _vm.group.some(function(g) {
                                                      return (
                                                        g.field == column.field
                                                      )
                                                    }))
                                              },
                                              on: {
                                                change: function($event) {
                                                  return _vm.handleChangeCheckbox(
                                                    column,
                                                    $event
                                                  )
                                                }
                                              },
                                              model: {
                                                value: column.visible,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    column,
                                                    "visible",
                                                    $$v
                                                  )
                                                },
                                                expression: "column.visible"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            [
                              _vm._v(" "),
                              _vm.filters &&
                              _vm.filters.filters.some(function(c) {
                                return c.field === column.field
                              })
                                ? _c("span", [
                                    _vm._v("Cannot hide filtered column")
                                  ])
                                : _c("span", [
                                    _vm._v("Cannot hide grouped column")
                                  ])
                            ]
                          ),
                          _vm._v(" "),
                          !_vm.hideReorderAndLock
                            ? _c(
                                "v-icon",
                                {
                                  class: [
                                    "k-lock-icon",
                                    { locked: column.locked }
                                  ],
                                  on: {
                                    click: function($event) {
                                      return _vm.handleClickLock(column)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(column.locked ? "lock" : "lock_open")
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.hideReorderAndLock
                            ? _c(
                                "v-icon",
                                { staticClass: "k-drag-sort-handle" },
                                [_vm._v("drag_indicator")]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    }),
                    0
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("v-divider", { staticStyle: { "margin-top": "8px" } }),
          _vm._v(" "),
          _c("v-list-tile", { staticClass: "k-column-action-btns" }, [
            _c(
              "a",
              {
                staticClass: "link--text",
                attrs: { href: "javascript:void(0)" },
                on: {
                  mousedown: function($event) {
                    $event.preventDefault()
                    return _vm.handleClickShowAllColumns($event)
                  }
                }
              },
              [_vm._v("Select All")]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "link--text",
                attrs: { href: "javascript:void(0)" },
                on: {
                  mousedown: function($event) {
                    $event.preventDefault()
                    return _vm.$emit("reset-default-columns")
                  }
                }
              },
              [_vm._v("Reset (to default)")]
            )
          ]),
          _vm._v(" "),
          _vm.SBuserIsAdmin && _vm.tableKey != ""
            ? _c("v-list-tile", { staticClass: "k-column-action-btns" }, [
                _c(
                  "a",
                  {
                    staticClass: "link--text",
                    attrs: {
                      href:
                        _vm.SbBaseUrl +
                        "/Admin/#/table-controls/" +
                        _vm.tableKey,
                      target: "_blank"
                    }
                  },
                  [_vm._v("\n        Configure this table\n      ")]
                )
              ])
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }